import React, { useState, useEffect } from "react";
import { ApiCall, Colors, Web_url } from "../../common/Const";
import { images } from "../../common/Images";
import "../../styles/OurCollections.css";
import Footer from "./Footer";
import Header from "./Header";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import String from "../../lang/String";
import { Pagination as Page } from "@mui/material";
import { MutatingDots } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function OurCollections() {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [collectionData, setCollectionData] = useState([]);
  const [countPage, setCountPage] = useState(0);
  const user = useSelector(state => state.auth.user)
  const navigate = useNavigate()
  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChangePage = (page) =>{
    getCollection((page-1)*4);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  const getCollection = (page = 0) => {
    const collectionParams = {next_page:page, 
      customer_id:  user && user.id > 0 ? user.id : 0
    }
    ApiCall("webCollection", collectionParams).then((data)=>{
      console.log('raw data =====> ',data);
      if(data.message_code == 'success'){
        setCollectionData(data.data);
        setCountPage(data.count);
      }
    }).catch((err)=>console.log(err));
  };

  console.log('collect display data  ======>',collectionData)

  useEffect(() => {
    getCollection();
  }, []);

  const texts = [
    {
      id: 1,
      head: "Theni Kamadhenu Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 2,
      head: "Trend Inspired",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
    {
      id: 3,
      head: "List Collections",
      para: "Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur quis elit bibendum, posuere velit nec, placerat magna. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla vulputate suscipit diam at congue. Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula. Morbi ante lacus, tincidunt in purus non, fringilla ornare metus. Duis blandit urna non pretium maximus. Sed lacus arcu, convallis eu ex et, volutpat aliquet turpis.",
    },
  ];
  
  const handleFavList = (id,ind,val, colInd) => {
    console.log("props", id,ind,val, colInd)
    let newValue = collectionData.map((data, inx) => {
      if(colInd === inx){
        collectionData[colInd].product.map((value, index) => {
          if(ind === index){
            value.fav_status = val== 0 ? 1 : 0;
          }
        })
      }
      return data
    })
    setCollectionData(newValue);

  const favParams = { customer_id: user && user.id > 0 ? user.id : 0, product_id:  id};
    if (val === 0) {
      ApiCall("addFav", favParams)
        .then((data) => {
          // console.log(data);
          if (data.message == "Success") {
            // console.log("res Fav",data);
          }
        })
        .catch((err) => console.log(err));
    } else {
      ApiCall("removeFav", favParams)
        .then((data) => {
          if (data.message == "Success") {
            // console.log('fav Res', data);
          }
        })
        .catch((err) => console.log(err));
    }
  }

  const viewDetails = (data) => {
    navigate("/product-details", { state: { p_detail: data } });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
    const handleMostViewedItems = (id) => {
      if (cusId === 0) {
        const guestviewedProducts =
          JSON.parse(sessionStorage.getItem("guestviewedProducts")) || [];

        if (guestviewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            guestviewedProducts.push(id);
            sessionStorage.setItem(
              "guestviewedProducts",
              JSON.stringify(guestviewedProducts)
            );
          })
          .catch((err) => console.log(err));
      } else {
        const viewedProducts =
          JSON.parse(sessionStorage.getItem("viewedProducts")) || [];

        if (viewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            viewedProducts.push(id);
            sessionStorage.setItem(
              "viewedProducts",
              JSON.stringify(viewedProducts)
            );
          })
          .catch((err) => console.log(err));
      }
    };


  return collectionData.length > 0 ? (
    <>
      <Header make={true} />
      <div style={{ backgroundColor: Colors.bg_color }}>
        <div className="container d-flex flex-column">
          <p className="our-coll-hd mt-5" style={{ color: Colors.Base_color }}>Discover Our Collections</p>
          
          {collectionData.map((collectionData,index) => {
            return [
              <div className="mb-5">
                <p className="our-coll-1-hd">{collectionData.collection_name}</p>
                <span className="our-coll-1-text" style={{ color: "gray" }}>
                  {collectionData.collection_description}
                </span>
                <div class="container mt-4 px-0">
                  <div className="d-flex gap-2 flex-row justify-content-center align-items-center">
                    {/* <img src={index%2 ? images.collImg : images.collImg1} className="coll-box-img" /> */}
                  </div>
                </div>
                <div className="container py-3">
                  <Swiper
                    slidesPerView={
                      windowSize != null && windowSize >= 1440
                        ? 6
                        : windowSize >= 1366
                        ? 5.2
                        : windowSize >= 1024
                        ? 5
                        : windowSize >= 768
                        ? 4
                        : windowSize >= 540
                        ? 3
                        : windowSize >= 410
                        ? 2
                        : windowSize >= 360
                        ? 1.7
                        : windowSize >= 280
                        ? 1.3
                        : 2
                    }
                    spaceBetween={20}
                    navigation={{
                      nextEl: ".review-swiper-button-next-1",
                      prevEl: ".review-swiper-button-prev-1",
                    }}
                    modules={[Navigation]}
                    className="mySwiper"
                  >
                    {collectionData.product.length > 0 ?collectionData.product.map((data, i) => {
                      return (
                        <SwiperSlide>
                          <div
                            className="card"
                            style={{
                              width:
                                windowSize <= 1024
                                  ? "10rem"
                                  : windowSize <= 769
                                  ? "10rem"
                                  : "12rem",
                              border: `1px solid ${Colors.Base_color}`,
                              borderRadius: "25px",
                              overflow: "hidden",
                            }}
                            role="button"
                          >
                            {/* <div className="d-flex justify-content-end">
                              <i
                                class="fa-regular fa-heart"
                                style={{
                                  color: Colors.Base_color,
                                  margin: "12px 10px 8px 0px",
                                }}
                              ></i>
                            </div> */}
                            <div className="d-flex justify-content-end" style={{position: 'absolute', top: 6, right: 6, zIndex: 999}}>
                                  {user && user.id > 0 && ( data.fav_status == 1 ? (
                                    <i
                                      class="fa-solid fa-heart"
                                      style={{
                                        color: Colors.Base_color,
                                        margin: "8px 9px 5px 0px",
                                      }}
                                      // onClick={() => handleFavList(false, data.product_id)}
                                      onClick={() => handleFavList(data.product_id,i,data.fav_status, index)}
//
                                    ></i>
                                  ) : (
                                    <i
                                      class="fa-regular fa-heart"
                                      style={{
                                        color: Colors.Base_color,
                                        margin: "8px 9px 5px 0px",
                                      }}
                                      // onClick={() => handleFavList(true, data.product_id)}
                                      onClick={() => handleFavList(data.product_id,i,data.fav_status, index)}
                                    ></i>
                                  ) )}
                                </div>
                            <img
                              // src={images.cardImg}
                              src={Web_url.Domain_url+''+data.product_image[0].url}
                              className="card-img-top"
                              alt="..."
                              style={{position: 'relative'}}
                              onClick={() => {viewDetails(data);handleMostViewedItems(data.product_id);}}
                            />
                            <div className="card-body" 
                            onClick={() => {viewDetails(data);handleMostViewedItems(data.product_id);}}
                            >
                              <p
                                className="card-title trd-title text-truncate"
                                style={{
                                  color: Colors.Base_color,
                                  marginBottom: "6px",
                                }}
                              >
                                {data.product_name}
                              </p>
                              <p
                                className="card-text"
                                style={{ color: "#000", marginBottom: "6px" }}
                              >
                                ₹ {data.product_price}
                                <small
                                  className="trd-strip-text mx-2"
                                  style={{
                                    color: "gray",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {data.actual_price}
                                </small>
                              </p>
                              <div className="d-flex justify-content-start card-offer-fil">
                                <span
                                  className=""
                                  style={{
                                    color: Colors.Base_color,
                                  }}
                                >
                                  {data.discount}% Offer
                                </span>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    }):<div></div>}
                  </Swiper>
                </div>
                <div className={collectionData.product.length > 5 ? "d-flex flex-row align-items-center justify-content-center gap-3" : "d-none"}>
                  <img
                    className="review-swiper-button-prev-1"
                    src={images.preBtn}
                    alt="left"
                    width="30"
                    height="30"
                  />
                  <img
                    className="review-swiper-button-next-1"
                    src={images.nxtBtn}
                    alt="left"
                    width="30"
                    height="30"
                  />
                </div>
                {/* <button
                  className="btn px-4 mx-2 mt-2"
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                  }}
                >
                  {String.our_collection.explore_collections}
                </button> */}
              </div>
            ]})
          }
        </div>
        <div className="container pb-5 d-flex justify-content-end">
          <Page count={(countPage / 4).toString().split(".")[1] == undefined ? parseInt((countPage / 4).toString().split(".")[0]) :parseInt((countPage / 4).toString().split(".")[0]) +1} variant="outlined" shape="rounded" onChange={(e,page)=>{handleChangePage(page)}}/>
        </div>
        <div className="container">
            <div className=" collections-text pb-5">
              {texts.map((texts) => {
                return (
                  <div className="j-collections mb-5 ">
                    <h3
                      className="mb-4"
                      style={{ color: "#126a38", fontWeight: "50" }}
                    >
                      {texts.head}
                    </h3>
                    <p style={{fontFamily: 'AvenirLTStdMedium', color: 'gray', fontSize: '18px'}}>{texts.para}</p>
                  </div>
                );
              })}
            </div>
          </div>
      </div>

      <Footer />
    </>
  ) : (<div className="d-flex align-items-center justify-content-center ban-box">
  <MutatingDots
    height="100"
    width="100"
    color={Colors.Base_color}
    secondaryColor={Colors.Base_color}
    radius="12.5"
    ariaLabel="mutating-dots-loading"
    wrapperStyle={{}}
    wrapperClass=""
    visible={true}
  />
</div>);
}

export default OurCollections;
